import { useCallback } from "react";

import { trackJourneyStep, trackMilestone } from "../services/analytics/google-analytics";

/**
 * Hook to emit analytics events
 *
 * @example
 * const { recordMilestone, recordJourneyStep } = useAnalytics();
 *
 * // Record a milestone outcome
 * recordMilestone('signup_complete', { signup_method: 'email' });
 *
 * // Record a journey step
 * recordJourneyStep('job_viewed', { job_id: '123', board: 'linkedin' });
 */
export const useAnalytics = () => {
  const recordMilestone = useCallback((eventName: string, params: Record<string, unknown> = {}) => {
    trackMilestone(eventName, params);
  }, []);

  const recordJourneyStep = useCallback(
    (eventName: string, params: Record<string, unknown> = {}) => {
      trackJourneyStep(eventName, params);
    },
    [],
  );

  return { recordMilestone, recordJourneyStep };
};
